(function($) {
	formHelper.addRule({
		form: '#form-forgot-password',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);